import { css } from 'styled-components'
import transformProps from '../utils/transformProps'
import { ConfigType, Dictionary, StyleType } from '../utils/transformProps/types'

type BorderColorKey =
    | 'borderColor'
    | 'borderYColor'
    | 'borderXColor'
    | 'borderTopColor'
    | 'borderBottomColor'
    | 'borderLeftColor'
    | 'borderRightColor'

export type BasicBorderKeys =
    | 'border'
    | 'borderRadius'
    | 'borderTopLeftRadius'
    | 'borderTopRightRadius'
    | 'borderBottomLeftRadius'
    | 'borderBottomRightRadius'
    | 'borderBottom'
    | 'borderLeft'
    | 'borderRight'
    | 'borderTop'
    | 'borderX'
    | 'borderY'

export type BorderKeys = BorderColorKey | BasicBorderKeys

type BorderColorProp = {
    [key in BorderColorKey]?: string | string[]
}

export type BorderProps = BorderColorProp & {
    [key in BasicBorderKeys]?: Dictionary
}

const borderConfig: ConfigType<BorderKeys> = {
    border: {
        property: ['borderWidth'],
    },
    borderX: {
        property: ['borderLeftWidth', 'borderRightWidth'],
    },
    borderY: {
        property: ['borderTopWidth', 'borderBottomWidth'],
    },
    borderBottom: {
        property: ['borderBottomWidth'],
    },
    borderLeft: {
        property: ['borderLeftWidth'],
    },
    borderRight: {
        property: ['borderRightWidth'],
    },
    borderTop: {
        property: ['borderTopWidth'],
    },
    borderColor: {
        property: ['borderColor'],
        scale: 'colors',
    },
    borderXColor: {
        property: ['borderLeftColor', 'borderRightColor'],
        scale: 'colors',
    },
    borderYColor: {
        property: ['borderTopColor', 'borderBottomColor'],
        scale: 'colors',
    },
    borderTopColor: {
        property: ['borderTopColor'],
        scale: 'colors',
    },
    borderBottomColor: {
        property: ['borderBottomColor'],
        scale: 'colors',
    },
    borderLeftColor: {
        property: ['borderLeftColor'],
        scale: 'colors',
    },
    borderRightColor: {
        property: ['borderRightColor'],
        scale: 'colors',
    },
    borderRadius: {
        property: ['borderRadius'],
        scale: 'radii',
    },
    borderTopLeftRadius: {
        property: ['borderTopLeftRadius'],
        scale: 'radii',
    },
    borderTopRightRadius: {
        property: ['borderTopRightRadius'],
        scale: 'radii',
    },
    borderBottomLeftRadius: {
        property: ['borderBottomLeftRadius'],
        scale: 'radii',
    },
    borderBottomRightRadius: {
        property: ['borderBottomRightRadius'],
        scale: 'radii',
    },
}

export const border = css<BorderProps>`
    ${(props): StyleType => transformProps(borderConfig, props)}
`
